import { createIcon } from '@chakra-ui/react';

export const CheckImageIcon = createIcon({
  displayName: 'CheckImageIcon',
  viewBox: '0 0 80 58',
  path: [
    <path
      key="1"
      d="M5 28.8519L27.75 51L75 5"
      stroke="white"
      strokeWidth="10"
      strokeLinecap="round"
    />
  ]
});
